const StateStatus = {
    idle: "idle",
    loading: "loading",
    succeeded: "succeeded",
    failed: "failed"

}
export default StateStatus